import { PrejimkaMenu } from '../../prejimka/prejimkamenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
// import { Doc } from '../../docs/components/Doc';
import { DocBrno } from '../../docs/components/DocBrno';

/**
 *
 * Prejimka se vyskytuje pouze u zakaznika MM Brno
 * zaloha ponechana
 */
const PrejimkaDocNewPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.prejimka ? (
        <AppWrapper
          appType={APP_TYPE.PREJIMKA}
          menu={<PrejimkaMenu />}
        >
          {/* <Doc /> */}
          <DocBrno />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default PrejimkaDocNewPage;
